/* Site search dialog. Markup in snippets/search-dialog.liquid, live results rendered
   by sections/predictive-search.liquid through Shopify's predictive search.
   Combobox pattern: focus stays in the input, arrow keys move aria-activedescendant. */
(function () {
  var dialog = document.getElementById('site-search');
  if (!dialog) return;

  // Without <dialog> support the openers stay plain links to the results page.
  if (typeof dialog.showModal !== 'function') return;

  var input = dialog.querySelector('[data-search-input]');
  var form = input.form;
  var openers = document.querySelectorAll('[data-search-open]');

  var root = document.documentElement;
  var listbox = dialog.querySelector('[data-search-listbox]');
  var body = dialog.querySelector('.psearch__body');
  var empty = dialog.querySelector('[data-search-empty]');
  var status = dialog.querySelector('[data-search-status]');
  var intro = dialog.querySelector('[data-search-intro]');
  var suggestUrl = dialog.getAttribute('data-suggest-url');
  var errorText = dialog.getAttribute('data-error-text') || '';

  var MIN_CHARS = 2;
  var mac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
  var cache = {};
  var timer = null;
  var controller = null;
  var lastQuery = '';
  var active = -1;
  var opener = null;
  var pressedBackdrop = false;

  function open(trigger) {
    if (dialog.open) return;
    opener = trigger || document.activeElement;
    dialog.showModal();
    root.classList.add('search-open');
    input.focus();
    input.select();
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  dialog.addEventListener('close', function () {
    root.classList.remove('search-open');
    if (opener && typeof opener.focus === 'function') opener.focus();
  });

  // The dialog fills the viewport, so a click on the dialog itself is a backdrop click.
  // Only when the press also started there: a text selection dragged out of the input
  // ends on the dialog too.
  dialog.addEventListener('pointerdown', function (e) {
    pressedBackdrop = e.target === dialog;
  });
  dialog.addEventListener('click', function (e) {
    if (pressedBackdrop && e.target === dialog) close();
    pressedBackdrop = false;
  });

  // Escape belongs to the dialog: keep it from page-level handlers such as the
  // whitepaper slide-in, which would otherwise dismiss itself as well.
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') e.stopPropagation();
  });

  openers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open(btn);
    });
    // They are links with role=button, so Space has to work like on a button.
    btn.addEventListener('keydown', function (e) {
      if (e.key === ' ') {
        e.preventDefault();
        open(btn);
      }
    });
  });

  dialog.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    var typing = t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName);
    // Cmd+K on a Mac, Ctrl+K elsewhere. Ctrl+K on a Mac is kill-line in text fields.
    var modifier = mac ? e.metaKey : e.ctrlKey;
    if ((e.key === 'k' || e.key === 'K') && modifier && !e.altKey && !e.shiftKey) {
      e.preventDefault();
      if (dialog.open) close(); else open();
    } else if (e.key === '/' && !typing && !dialog.open && !e.metaKey && !e.ctrlKey && !e.altKey) {
      e.preventDefault();
      open();
    }
  });

  // Shortcut hint: the platform's own modifier.
  document.querySelectorAll('[data-search-kbd]').forEach(function (k) {
    k.textContent = mac ? '⌘K' : 'Ctrl K';
  });

  /* ── Options and keyboard ───────────────────────────────── */
  function options() {
    return listbox.querySelectorAll('[role="option"]');
  }

  function setActive(i, scroll) {
    var opts = options();
    if (opts[active]) opts[active].setAttribute('aria-selected', 'false');
    active = i;
    if (opts[i]) {
      opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      // Back at the top, show the first group label too.
      if (scroll && i === 0) body.scrollTop = 0;
      else if (scroll) opts[i].scrollIntoView({ block: 'nearest' });
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }

  input.addEventListener('keydown', function (e) {
    if (e.isComposing || e.keyCode === 229) return;
    var n = options().length;
    if (e.key === 'Escape') {
      // Close on the first press; type=search would otherwise only clear the field.
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowDown' && n) {
      e.preventDefault();
      setActive(active + 1 >= n ? 0 : active + 1, true);
    } else if (e.key === 'ArrowUp' && n) {
      e.preventDefault();
      setActive(active <= 0 ? n - 1 : active - 1, true);
    } else if (e.key === 'Enter' && active > -1 && options()[active]) {
      e.preventDefault();
      window.location.href = options()[active].href;
    }
  });

  // Mouse and keyboard share one highlight; the mouse never scrolls the list.
  listbox.addEventListener('mousemove', function (e) {
    var opt = e.target.closest('[role="option"]');
    if (!opt) return;
    var i = Array.prototype.indexOf.call(options(), opt);
    if (i !== active) setActive(i, false);
  });

  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });

  /* ── Suggestions ────────────────────────────────────────── */
  dialog.querySelectorAll('[data-search-term]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      input.value = chip.getAttribute('data-search-term');
      input.focus();
      setActive(-1);
      search();
    });
  });

  /* ── Fetching and rendering ─────────────────────────────── */
  input.addEventListener('input', function () {
    // Any edit drops the highlight, so Enter searches the new text, not an old hit.
    setActive(-1);
    clearTimeout(timer);
    timer = setTimeout(search, 160);
  });

  function stopLoading() {
    if (controller) controller.abort();
    controller = null;
    dialog.classList.remove('is-loading');
  }

  function render(data) {
    setActive(-1);
    if (!data) {
      listbox.innerHTML = '';
      empty.hidden = true;
      empty.textContent = '';
      intro.hidden = false;
      status.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      dialog.classList.remove('has-options');
      return;
    }
    listbox.innerHTML = data.options;
    // Point 'all results' at exactly what Enter would submit; the rendered href is
    // built from HTML-escaped terms and breaks on & or quotes.
    var all = listbox.querySelector('#psearch-all');
    if (all) all.href = form.action + '?' + new URLSearchParams(new FormData(form)).toString();
    empty.textContent = data.empty;
    empty.hidden = !data.empty;
    // Nothing found: keep the suggestions, they are the way forward.
    intro.hidden = !data.empty;
    status.textContent = data.status;
    input.setAttribute('aria-expanded', data.options ? 'true' : 'false');
    dialog.classList.toggle('has-options', !!data.options);
  }

  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var text = function (sel) {
      var el = doc.querySelector(sel);
      return el ? el.textContent.trim() : '';
    };
    var opts = doc.querySelector('[data-psearch-options]');
    return {
      options: opts ? opts.innerHTML.trim() : '',
      empty: text('[data-psearch-empty]'),
      status: text('[data-psearch-status]')
    };
  }

  function search() {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;

    if (q.length < MIN_CHARS) {
      stopLoading();
      render(null);
      return;
    }
    if (cache[q]) {
      stopLoading();
      render(cache[q]);
      return;
    }

    stopLoading();
    controller = new AbortController();
    var own = controller;
    dialog.classList.add('is-loading');

    var params = new URLSearchParams();
    params.set('q', q);
    params.set('section_id', 'predictive-search');
    params.set('resources[type]', 'page,article');
    params.set('resources[limit]', '5');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][fields]', 'title,body,tag');
    params.set('resources[options][prefix]', 'last');

    fetch(suggestUrl + '?' + params.toString(), { signal: own.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var data = parse(html);
        cache[q] = data;
        if (controller === own) {
          dialog.classList.remove('is-loading');
          controller = null;
        }
        if (input.value.trim() === q) render(data);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        if (controller === own) {
          dialog.classList.remove('is-loading');
          controller = null;
        }
        // Never leave the previous query's hits on screen; Enter still searches all pages.
        if (input.value.trim() === q) render({ options: '', empty: errorText, status: errorText });
        // Let a retry with the same text go through instead of being skipped.
        lastQuery = '';
      });
  }
})();
